// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__2Zt5d","calculations":"App_calculations__nhiXv"};